module.exports = __webpack_public_path__ + "static/media/group-survey-title1.27a8363e.jpg";